module.exports = __webpack_public_path__ + "disc-ip6.png?de5fdcbc3ee813d23ab5d9e272e0cc57";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/disc-ip6.png
// module id = 64
// module chunks = 0